import { render, staticRenderFns } from "./roadBook.vue?vue&type=template&id=5a447344&"
import script from "./roadBook.vue?vue&type=script&lang=js&"
export * from "./roadBook.vue?vue&type=script&lang=js&"
import style0 from "./roadBook.vue?vue&type=style&index=0&id=5a447344&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports